import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useEffect, useState } from "react";
import ButtonWithConfirm from "./modal.confirm-dialog.component";
import { LocationPicker } from "./location-picker.component";

interface Props {
  open: boolean;
  productCount: number;
  onCancel: () => void;
  onMove: (location: string) => void;
}

// Bulk move of the ticked products on the product list to a location.
// Composes the shared LocationPicker with the standard confirmation button;
// the confirmation carries the same merge warning as the Locations page.
const MoveLocationModal = (props: Props) => {
  const [location, setLocation] = useState<string | null>(null);

  useEffect(() => {
    if (props.open) setLocation(null);
  }, [props.open]);

  const n = props.productCount;
  const noun = `${n} product${n !== 1 ? "s" : ""}`;

  return (
    <Dialog open={props.open} onClose={props.onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Move {noun}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Choose the location to move the selected {noun} to, or type a name to
          create a new location.
        </DialogContentText>
        <Box sx={{ mt: 1 }}>
          <LocationPicker
            value={location}
            onChange={setLocation}
            allowNew
            autoFocus
            label="New location"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={props.onCancel}>
          Cancel
        </Button>
        <div style={{ flex: "1 0 0" }} />
        <ButtonWithConfirm
          variant="contained"
          color="primary"
          disabled={!location}
          okButtonLabel="Move"
          message={`Please confirm you wish to move ${noun} to ${location}. If this location already exists products will be merged. This operation cannot be undone!`}
          onOk={() => location && props.onMove(location)}
        >
          Move
        </ButtonWithConfirm>
      </DialogActions>
    </Dialog>
  );
};

export default MoveLocationModal;
